import { convertNumbersToProperFormat } from 'utils/number';

export const DEFAULT_AI_GPT_MODEL = 'gpt-5-mini';

export const DEFAULT_AI_IMAGE_GENERATION_MODEL = 'gpt-image-2';

export const AI_GPT_MODEL_OPTIONS = [
  // { value: 'gpt-5-nano', label: 'GPT-5 Nano' },
  { value: 'gpt-5-mini', label: 'GPT-5 Mini' },
  { value: 'gpt-4o', label: 'GPT-4o' },
  // { value: 'gpt-4.1', label: 'GPT-4.1' },
  { value: 'gpt-5', label: 'GPT-5' },
] as const;

export const formatAiCompletionDuration = (ms: number): string => {
  const seconds = ms / 1000;
  if (seconds < 60) {
    return `${convertNumbersToProperFormat(Number(seconds.toFixed(0)))}s`;
  }

  const minutes = convertNumbersToProperFormat(Math.floor(seconds / 60));
  const remainingSeconds = convertNumbersToProperFormat(
    Math.round(seconds % 60)
  );
  return `${minutes}m ${remainingSeconds}s`;
};
